const burger = function()
{
  var burger = document.getElementById('hamburger')
  var menuWrap = document.querySelector('.header__nav')
  var header = document.querySelector('.header')
  if(!burger) return;
  burger.addEventListener('click', toggleBurger)
  function toggleBurger() {
    burger.classList.toggle("is-active")
    menuWrap.classList.toggle("header__nav--active")
    header.classList.toggle("header--fix")
  }
}

export default burger();